var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ 'background-color': _vm.$vuetify.theme.themes.light.backgroundHome })},[_c('HomeCadu',{ref:"homeCadu",on:{"reloadHeader":function($event){return _vm.$emit('reloadHeader')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }